var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
/**
 * To show a boolean value as a YES | NO string.
 */
const BooleanDisplay = (_a) => {
    var { val } = _a, otherProps = __rest(_a, ["val"]);
    return (_jsx("span", Object.assign({}, otherProps, { className: classNames("badge", otherProps.className, {
            "badge-success": val,
            "badge-secondary": !val,
        }), children: val ? "Yes" : "No" })));
};
export default BooleanDisplay;
